export default "__VITE_ASSET__de8b70d4__"